import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import StringUtilService from 'commons-forms/services/StringUtilService/StringUtilService.js';
import ValidationService from 'commons-forms/services/ValidationService/ValidationService.js';

import InputText from 'commons-forms/components/InputText/InputText.jsx';

import FIELD_LENGTH from 'commons-forms/constants/fieldLength.js';

class InputPhoneNumber extends React.Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.maskValue = this.maskValue.bind(this);
        this.validInput = this.validInput.bind(this);
    }

    componentWillMount() {
        this.handleInputChange(this.props.value);
    }

    componentWillReceiveProps(nextProps) {
        const oldValues = this.props.value;
        const newValues = nextProps.value;

        if (oldValues !== newValues) {
            this.handleInputChange(nextProps.value);
        }
    }

    shouldComponentUpdate(nextProps) {
        const oldValues = this.props.value;
        const newValues = nextProps.value;

        return oldValues !== newValues || this.props.hasBeenSubmit !== nextProps.hasBeenSubmit;
    }

    maskValue(value) {
        const trimValue = StringUtilService.formatPhoneNumber(value);
        const trimValueLength = trimValue.length;
        const areaCode = trimValue.substring(0, 3);
        const prefix = trimValue.substring(3, 6);
        const subscriberNumber = trimValue.substring(6, 10);

        if (trimValueLength <= 3) {
            return `${areaCode}`;
        }
        if (trimValueLength <= 6) {
            return `(${areaCode}) ${prefix}`;
        }

        return `(${areaCode}) ${prefix}-${subscriberNumber}`;
    }

    validInput(value) {
        const trimValue = StringUtilService.formatPhoneNumber(value);
        const validation = ValidationService.validatePhoneNumber(trimValue);

        if (this.props.isRequired) {
            return validation && ValidationService.validateIsNotEmpty(trimValue);
        }

        return isEmpty(value) || validation;
    }

    handleInputChange(value) {
        const maskValue = this.maskValue(value);

        this.props.valueChange({
            name: this.props.name,
            value: StringUtilService.formatPhoneNumber(value),
            validation: this.validInput(maskValue),
        });
    }

    render() {
        return (
            <InputText
                type="tel"
                name={this.props.name}
                classNames={['InputPhoneNumber', ...this.props.classNames]}
                label={this.props.label}
                errorLabel={this.props.errorLabel}
                value={this.maskValue(this.props.value)}
                isRequired={this.props.isRequired}
                isValid={this.props.isValid}
                valueChange={this.handleInputChange}
                onBlur={this.props.onBlur}
                hasBeenSubmit={this.props.hasBeenSubmit}
                dataTest={this.props.dataTest}
                maxLength={FIELD_LENGTH.PHONE_NUMBER_MAX}
            />
        );
    }
}

InputPhoneNumber.defaultProps = {
    isRequired: false,
    hasBeenSubmit: false,
    classNames: [],
    errorLabel: '',
    onBlur: () => {},
    dataTest: '',
};

InputPhoneNumber.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    errorLabel: PropTypes.string,
    hasBeenSubmit: PropTypes.bool,
    isRequired: PropTypes.bool,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    valueChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    dataTest: PropTypes.string,
};

InputPhoneNumber.displayName = 'InputPhoneNumber';

export default InputPhoneNumber;
